export default "__VITE_ASSET__CMPaUnIG__"